import styled from "@emotion/styled"
import { spacingStaticMd, spacingStaticXl } from "@porsche-design-system/components-react/emotion"
import type { DatePrice, FormattedMsrp } from "@slfinrtl/ui-bff-routes"
import { Flex } from "src/components/Flex"
import { CheckboxField, FormLayout, InputField } from "src/components/form"
import { GridItem } from "src/components/grid/GridItem"
import { gridSize } from "../../../common/gridSize.const"
import { Msrp } from "../../components"
import { PricingFormGrid } from "../../components/PricingFormGrid"
import { PriceHistory } from "../../components/priceHistory/PriceHistory"
import type { AlwaysVatDeductibleBasicPricingFields } from "../alwaysVatDeductibleBasicPricing.fields"

export interface AlwaysVatDeductibleBasicPricingFormProps {
	fields: AlwaysVatDeductibleBasicPricingFields
	formattedMsrp?: FormattedMsrp
	priceHistory: DatePrice[] | undefined
}

export const AlwaysVatDeductibleBasicPricingForm = ({
	fields,
	formattedMsrp,
	priceHistory,
}: AlwaysVatDeductibleBasicPricingFormProps) => {
	return (
		<PricingFormGrid>
			<GridItemFormLayout size={gridSize}>
				<InputField {...fields.price} />
				{fields.vatDeductible && <VatDeductibleCheckboxField {...fields.vatDeductible} />}
				<InputField {...fields.minimumPrice} />
				<InputField {...fields.purchasePrice} />
			</GridItemFormLayout>

			<PriceHistoryContainer size={gridSize} $direction="column">
				{priceHistory && priceHistory.length > 0 && <PriceHistory view={priceHistory} />}
				{formattedMsrp && <Msrp view={formattedMsrp} />}
			</PriceHistoryContainer>
		</PricingFormGrid>
	)
}

const StyledFlex = styled(Flex)`
	gap: ${spacingStaticXl};
`

const StyledFormLayout = styled(FormLayout)`
	align-self: start; /* needed when price history is larger than form, otherwise gaps between inputs increase */
`

const GridItemFormLayout = StyledFormLayout.withComponent(GridItem)
const PriceHistoryContainer = StyledFlex.withComponent(GridItem)

const VatDeductibleCheckboxField = styled(CheckboxField)`
	margin-bottom: ${spacingStaticMd};
`
